import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import Loader from '../../_common/Loader'
import { URL, deleteMsg } from '../../../const'
import { toggleVisibility, showToast } from '../../../actions'
import RoleControlled from '../../_common/RoleControlled'

export class Garbage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      show_panel: true,
      pdfURL: '',
      pdf: null,
      loading: true,
      deleteMode: false
    }
  }
  componentDidMount () {
    this._fetchData()
  }
  async _fetchData () {
    this.setState({ loading: true })
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    try {
      const res = await axios.get(
        `${URL}garbage_pdf/${this.props.propertyID}`,
        config
      )

      this.setState({
        pdfURL: res.data.file_url,
        loading: false
      })
    } catch (error) {
      console.log('An error occured while fetching owner informations.')
    }
  }

  _handleEnablePanel = (e) => {
    this.setState({ show_panel: e.target.checked })
    this.props.toggleVisibility(this.props.propertyID, 5, e.target.checked)
  }
  _handleAddPDF (e) {
    const pdf = e.target.files[0]
    console.log(pdf)
    if (pdf) {
      if (pdf.type === 'application/pdf' && pdf.name.indexOf('pdf') > 0) {
        this.setState({ pdf })
        this._handleSave(pdf)
        // console.log('sending pdf file')
      } else {
        console.log('wrong file type')
        this.props.showToast('PDFファイルを選択してください。', 'danger')
      }
    }
  }
  async _handleSave (pdf) {
    const url = `${URL}garbage_pdf/${this.props.propertyID}`
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    // console.log('pdf: ', pdf)
    // console.log('url: ', url)
    try {
      const formData = new FormData()
      if (pdf) {
        formData.append('file', pdf, `garbage-${this.props.propertyID || '000'}-${Date.now()}.pdf`)
      }
      await axios.post(
        url,
        formData,
        config
      )
      // console.log('post res: ', res)
      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
    } catch (error) {
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }
  _deleteData = async () => {
    const res = window.confirm(deleteMsg)
    if (res) {
      const url = `${URL}garbage_pdf/${this.props.propertyID}`
      const config = {
        headers: {
          'Authorization': `Token ${this.props.user.token}`
        }
      }
      try {
        const res = await axios.delete(
          url,
          config
        )
        console.log('post res: ', res)
        this.props.showToast('削除しました', 'danger')
        this._fetchData()
      } catch (error) {
        console.log('error: ', error)
        this.props.showToast('削除に失敗しました。', 'danger')
      }
    }
  }
  _renderMain () {
    if (!this.state.loading) {
      return (
        <div className="garbage_main">
          <div className="garbage_form">
            <label htmlFor="add_garbage" className="btn primary flex align-center">
              <svg viewBox="0 0 24 24" className="icon_upload">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
              <span>PDFファイル</span>
              <input
                type="file"
                id="add_garbage"
                onChange={this._handleAddPDF.bind(this)}
              />
            </label>
            <button className="btn red" onClick={this._deleteData}>ゴミカレンダーを削除</button>
          </div>
          {
            this.state.pdfURL
              ? (
                <div className="pdf_container">
                  <embed src={`${this.state.pdfURL}`} type="application/pdf" width="100%" height="600px" />
                </div>
              )
              : null
          }
        </div>

      )
    } else {
      return <Loader key="loader" classname="loader_dot_circle small"/>
    }
  }

  render () {
    if (this.props.activeDetails.data.owner_id === 1) { return null }
    return (
      <div className="garbage flex column">
        <h4 className="page_title bold flex justify-between">
          <span>ゴミカレンダー登録</span>
          <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
            <div className="switch">
              <input
                type="checkbox"
                id="showSwitch"
                className="switch-input"
                key="checkbox"
                value=""
                onChange={this._handleEnablePanel}
                checked={this.state.show_panel}
              />
              <label htmlFor="showSwitch" className="switch-label" key="label">
                <span className="toggle--on">表示</span>
                <span className="toggle--off">非表示</span>
              </label>
            </div>
          </RoleControlled>
        </h4>
        {
          this.state.show_panel
            ? this._renderMain()
            : null
        }
      </div>
    )
  }
}

function mapStateToProps ({ user, activeDetails }) {
  return { user, activeDetails }
}

export default connect(mapStateToProps, { toggleVisibility, showToast })(Garbage)



// WEBPACK FOOTER //
// ./src/components/Properties/Garbage/index.js